<template>
  <h1 v-if="eventItem">
    <router-link :to="'/events/'+ eventItem.id">
      <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
    </router-link>
  </h1>

  <OfflineMode />

  <div class="container-fluid container-lg text-center" v-if="roomItems">
    <h2>{{ roomItems.title }}</h2>

    <div v-for="roomItem in roomItems.items" class="accordion"
      :key="roomItem.id">
      <router-link :to="'/events/'+ eventItem.id +'/rooms/booking/day-'+ dayid +'/room-'+ roomItem.id" class="text-uppercase font-bold py-2">
        {{ roomItem.title }}
      </router-link>
      <div class="text-start mt-2">
        <div v-if="roomItem.stand"><span class="font-bold">Stand:</span> {{ roomItem.stand }}</div>
        <div v-if="roomItem.pax"><span class="font-bold">Capacity:</span> max {{ roomItem.pax }} pax</div>
        <div v-if="roomItem.text">
          <span class="font-bold">Info: </span> 
          <span v-html="roomItem.text"></span>
        </div>
      </div>
      <button type="button" class="btn btn-coesia my-2" @click="bookNow(roomItem)">
        <i class="fas fa-chalkboard-teacher me-2"></i>
        Book now in {{ roomItem.title }}
      </button>
    </div>
    <div class="accordion mb-4"></div>

  </div>
</template>

<script>
import OfflineMode from '../OfflineMode';

export default {
  name: 'CalendarDay',
  props: ['id', 'dayid'],
  computed: {
    eventItem () {
      return this.$store.getters.fairItemFromId(Number(this.id))
    },
    roomItems () {
      let roomItems = this.$store.getters.roomItemsFromDay(Number(this.dayid))
			//console.log(roomItems)
			if (roomItems && roomItems.items && roomItems.items.length == 1) {
				this.redirect(roomItems)
			}
      return roomItems
    },
  },
  methods: {
		redirect(roomItems) {
			let detailUrl = '/events/'+ this.eventItem.id +'/rooms/booking/day-'+ this.dayid +'/room-'+ roomItems.items[0].id
			this.$router.replace(detailUrl)
		},
		bookNow(roomItem) {
			let url = '/events/'+ this.eventItem.id +'/rooms/booking/day-'+ this.dayid +'/room-'+ roomItem.id
			this.$router.push(url)
		}
  },
  components: {
    OfflineMode
  }
}
</script>

<style scoped>
.accordion {
  border-top: 1px solid #DA052C;
  margin: 1rem 0 0;
  padding-top: 1rem;
}
</style>
